const config = {
  ENV: process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'production',
  API_URL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : '',
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN ? process.env.REACT_APP_SENTRY_DSN : '',
  XERO_PRICING_PLAN_URL:
    'https://apps.xero.com/subscribe/4911c3cb-d8e2-4993-ae1b-03afe1222f03',
}

export default config
